import {ComponentFactoryResolver, ComponentRef, Injectable, Injector} from '@angular/core';
import {SweetAlertOptions} from 'sweetalert2';
import Swal from 'sweetalert2/src/sweetalert2';

type EventFunction = (event: any) => void;

@Injectable({
    providedIn: 'root'
})
export class SwalComponentService {

    component: ComponentRef<any>;

    setting: SweetAlertOptions;

    defaults: SweetAlertOptions = {
      showCancelButton: false,
      showConfirmButton: false
    };

    constructor(private resolver: ComponentFactoryResolver, private injector: Injector) {}

    /** options son las opciones de sweetalert **/
    async fire(component: any, componentData: any, events: any, options: SweetAlertOptions) {


        this.component = this.getComponentRef(component, componentData, events);

        const settings = Object.assign(this.defaults, options,  {
            html: this.component.location.nativeElement
        });

        this.setting = settings;

        const result = await Swal.fire(settings);

        this.component.destroy();

        return  result;
    }

    private getComponentRef(component: any, componentData?: any, events?: any) {

        const factory = this.resolver.resolveComponentFactory(component);

        const componentRef: ComponentRef<any> = factory.create(this.injector);

        if (componentData) {

            Object.keys(componentData).forEach(k => {
                componentRef.instance[k] = componentData[k];
            });
        }

        if (events) {

            Object.keys(events).forEach(k => {

                this.bind(componentRef, k, events[k]);
            });
        }

        componentRef.changeDetectorRef.detectChanges();

        return componentRef;
    }

    private bind(componentRef: ComponentRef<any>, event: string, fn: EventFunction) {

        if (!componentRef.instance[event]) {

            console.warn(`Evento ${event} no ofrecido por el component`);
            return;
        }

        componentRef.instance[event].subscribe((eventData: any) => {

            fn(eventData);
        });
    }

    public async close() {

        return Swal.close();
    }

}
